import { useTranslation } from "react-i18next";
import { OnboardingTooltip } from "@/shared/ui";
import { getSocialCategoryIconConfig } from "@/features/hr/employees/consts/socialCategoryIcons";
import { getSocialCategoryLabel } from "@/features/hr/employees/consts/socialCategories";
import type { SocialCategory } from "../../../types";

interface Props {
  categories: SocialCategory[];
}

export default function EmployeeSocialCategoryIcons({ categories }: Props) {
  const { t } = useTranslation("EmployeesPage");

  const mappedCategories = categories.filter((cat) => getSocialCategoryIconConfig(cat.category_type) !== null);

  if (mappedCategories.length === 0) return null;

  const tooltipContent = (
    <div className="flex flex-col gap-2 min-w-36">
      <p className="text-label-xs content-on-background-neutral">{t("socialCategories.title")}</p>
      {categories.map(function renderTooltipItem(cat, index) {
        const config = getSocialCategoryIconConfig(cat.category_type);
        const IconComponent = config?.Icon;
        const label = getSocialCategoryLabel(cat.category_type, t);
        return (
          <div key={index} className="flex items-center gap-2">
            {IconComponent ? (
              <span className={`shrink-0 ${config!.colorClass}`}>
                <IconComponent size={16} color="currentColor" variant="Bold" />
              </span>
            ) : (
              <div className="w-4 h-4 shrink-0" />
            )}
            <span className="text-body-regular-xs content-on-background-neutral">{label}</span>
          </div>
        );
      })}
    </div>
  );

  return (
    <OnboardingTooltip content={tooltipContent} align="left">
      <div className="flex items-center gap-1">
        {mappedCategories.map(function renderIcon(cat, index) {
          const config = getSocialCategoryIconConfig(cat.category_type)!;
          const IconComponent = config.Icon;
          return (
            <span key={index} className={config.colorClass}>
              <IconComponent size={16} color="currentColor" variant="Bold" />
            </span>
          );
        })}
      </div>
    </OnboardingTooltip>
  );
}
